// Shown while the organiser looks at the app as a group ("Zobrazit jako skupina").
import React, { useState } from 'react';
import { Eye } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

export default function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user?.impersonatedBy) return null;
  return (
    <div role="status" className="border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-900 print:hidden">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-3 gap-y-2">
        <Eye className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <span>
          Prohlížíte aplikaci jako skupina <strong>{user.groupName || user.email}</strong>. Co tady uložíte, uloží se za
          skupinu.
        </span>
        <button
          type="button"
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            await stopImpersonation();
          }}
          className="ml-auto rounded-md bg-amber-600 px-3 py-1 font-medium text-white hover:bg-amber-700 disabled:opacity-60"
        >
          Zpět do administrace
        </button>
      </div>
    </div>
  );
}
